'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['buffer', 'network'],
    data: function data() {
        return {};
    },
    methods: {
        joinChannel: function joinChannel() {
            this.buffer.flags.channel_badkey = false;
            this.buffer.join();
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["BufferKey"]
window._kiwi_exports.components.BufferKey = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BufferKey.vue
// module id = Gx5t
// module chunks = 1